//@ flow
const restoreBaselineValues = () => {
    window.dispatchEvent(
        new CustomEvent('baselineRestored', {
            detail: {
                payload: 'Baseline Price restored successfully',
                stopLoading: true,
                type: 'success',
            }
        })
    );
    return;
}

export default restoreBaselineValues;
